import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealEstateRoutingModule } from './realestate-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RealEstateRoutingModule
  ]
})
export class RealEstateModule { }
